/**
 * storage情報を扱うためのwrapperクラス
 * sessionStorage, localStorageを切り替えられるようにwrapperクラスとして本クラスは存在する
 */
class StorageManager {
  /**
   * 保存
   * @param {*} key
   * @param {*} value
   */
  static setItem(key, value) {
    sessionStorage.setItem(key, value);
  }

  /**
   * 取得
   * @param {*} key
   */
  static getItem(key) {
    return sessionStorage.getItem(key);
  }

  /**
   * 削除
   * @param {*} key
   */
  static removeItem(key) {
    sessionStorage.removeItem(key);
  }
}

export default StorageManager;
